module.exports = __webpack_public_path__ + "assets/img/withdraw.98720123.png";